import React from "react";
import { Route, Routes } from "react-router-dom";
import { HomePage } from "./pages/home";
import { LoginPage } from "./pages/login";
import { RouterLayout } from "./common/RouterLayout";
import { ProviderPage } from "./pages/providers/provider";
import { ProvidersPage } from "./pages/providers";
import { PaymentsPage } from "./pages/payments";
import { ProductPage } from "./pages/products/product";
import PackagesPage from "./pages/packages/index";
import PagosVendedores from "./pages/packages/PagosVendedores";
import { CategorySelection } from "./pages/packages-group/CategorySelection";
import { GroupPackagesPage } from "./pages/packages-group/index";
import UsersPage from "./pages/users/index";

export const AppRouter: React.FC<{}> = () => {
  return (
    <Routes>
      <Route element={<RouterLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/proveedor/:id" element={<ProviderPage />} />
        <Route path="/proveedores" element={<ProvidersPage />} />
        <Route path="/pagos" element={<PaymentsPage />} />
        <Route path="/pagos-vendedores" element={<PagosVendedores />} />
        <Route path="/producto/:id" element={<ProductPage />} />
        <Route path="/paquetes" element={<PackagesPage />} />
        <Route path="/paquetes-grupales" element={<CategorySelection />} />
        <Route path="/paquetes-grupales/:category" element={<GroupPackagesPage />} />
        <Route path="/usuarios" element={<UsersPage />} />
      </Route>
    </Routes>
  );
};

